import { render, staticRenderFns } from "./number.vue?vue&type=template&id=2abce430&scoped=true&"
import script from "./number.vue?vue&type=script&lang=js&"
export * from "./number.vue?vue&type=script&lang=js&"
import style0 from "./number.vue?vue&type=style&index=0&id=2abce430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abce430",
  null
  
)

export default component.exports